import React from 'react'
import Tooltip from '@mui/material/Tooltip'

const TooltipLabel = ({ text, tooltip }: { text: string; tooltip?: string }) =>
  tooltip ? (
    <Tooltip title={tooltip} placement="top" arrow>
      <span>
        {text}
        <i className="fa fa-info-circle ms-1" />
      </span>
    </Tooltip>
  ) : (
    <>{text}</>
  )

export default TooltipLabel
